export default __webpack_public_path__ + "static/media/Ocean reef6.20edf2a4.jpg";